import dayjs, { Dayjs } from "dayjs";

// Keep regexes in sync with server/src/utils/validationUtils.ts

export const isEmailInvalid = (email: string): boolean => {
  return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

// Letters including umlauts, plus spaces, hyphens, and apostrophes. No digits.
export const isNameInvalid = (name: string): boolean => {
  return !/^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž]+(?:[-'\s][A-Za-zÀ-ÖØ-öø-ÿĀ-ž]+)*$/.test(name.trim());
};

// Must start with + or a digit, followed by digits and spaces only. E.g. +49 171 1234567
export const isPhoneInvalid = (phone: string): boolean => {
  return !/^[+\d][\d\s]{4,19}$/.test(phone);
};

export const isBirthdayInvalid = (birthday: Dayjs): boolean => {
  return birthday.isAfter(dayjs());
};
